import { useInView } from '../../hooks/useInView';
import { Star, Award, Briefcase, DollarSign, Quote } from 'lucide-react';

const highlights = [
  { icon: Award, label: '15+ anos de experiência' },
  { icon: Briefcase, label: '+500 clientes atendidos' },
  { icon: DollarSign, label: 'Consultorias a partir de R$ 5.000' },
];

export default function ExpertSection() {
  const [ref, isInView] = useInView({ threshold: 0.1 });

  return (
    <section className="relative py-32 overflow-hidden" data-testid="expert-section">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-primary/[0.04] to-background" />

      <div className="relative mx-auto max-w-5xl px-6" ref={ref}>
        <div className={`text-center max-w-2xl mx-auto mb-14 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary mb-4 block">Opinião de Especialista</span>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-foreground">
            O que os especialistas dizem?
          </h2>
        </div>

        <div className={`relative rounded-3xl border border-border/60 bg-card/70 backdrop-blur-sm p-8 md:p-12 shadow-2xl transition-all duration-1000 ${isInView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <Quote className="absolute top-6 right-6 w-16 h-16 text-primary/10" />

          <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-8 pb-8 border-b border-border/40">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary/25 to-primary/5 border border-primary/30 flex items-center justify-center text-primary font-bold text-2xl shrink-0">
              RA
            </div>
            <div className="flex-1">
              <div className="text-xl font-bold text-foreground">Dr. Ricardo Almeida</div>
              <div className="text-sm text-muted-foreground mb-2">Consultor Financeiro</div>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
                <span className="text-primary font-semibold">CPA-20 · CFP®</span>
                <span className="text-muted-foreground">·</span>
                <div className="flex items-center gap-0.5 text-primary">
                  {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="w-3 h-3 fill-current" />)}
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-5 text-foreground/90 leading-relaxed italic">
            <p>
              &ldquo;Eu trabalho com consultoria financeira há mais de 15 anos e já cheguei a cobrar mais de R$ 5.000 por uma consultoria completa para organizar a vida financeira de uma pessoa. E olha, o que a Aretê entrega por menos de R$ 30 por mês é absurdamente bom.&rdquo;
            </p>
            <p>
              &ldquo;A plataforma tem dashboard profissional, controle de gastos, metas, acompanhamento de investimentos, notícias do mercado em tempo real e ainda por cima <strong className="text-primary not-italic font-semibold">dicas personalizadas por inteligência artificial</strong>. É exatamente o tipo de ferramenta que eu recomendaria para qualquer pessoa que quer ter controle financeiro de verdade.&rdquo;
            </p>
            <p>
              &ldquo;O preço é justo demais. É a melhor relação custo-benefício que já vi no mercado de finanças pessoais no Brasil. Sem comparação.&rdquo;
            </p>
            <p className="not-italic text-muted-foreground text-sm">
              &ldquo;Acho que vou ficar sem emprego kkkkkk&rdquo; 😂
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-border/40 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {highlights.map((h) => {
              const Icon = h.icon;
              return (
                <div key={h.label} className="flex items-center gap-2.5 text-sm">
                  <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4" />
                  </div>
                  <span className="text-foreground/80 font-medium">{h.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
